module.exports = __webpack_public_path__ + "static/media/florida_department_agriculture.5ae03bff.png";